import React from 'react';
import classNames from 'classnames';


export interface RBGProps {
  options: RBGOption[];
  name: string;
  label: string;
  value: any;
  onChange: (e: CustomEvent<any>) => void;
}


export interface RBGOption {
  value: any;
  label: string;
}


export function RadioButtonGroup(props: RBGProps) {
  return (
  <div>
    <div className="btn-group" role="group" aria-label="{label}">
      {props.options.map(o => (
        <button type="button" key={o.value} className={classNames("btn", { 
          'btn-primary': o.value === props.value,
          'btn-default': o.value !== props.value,
          })}
          onClick={() => props.onChange(new CustomEvent('change', {
            detail: o.value,
          }))}>{o.value === props.value ? (<span>&#9679;&nbsp;</span>) : ''}{o.label}</button>
      ))}
    </div>
  </div>
  )
}


export default RadioButtonGroup;
